module.exports = __webpack_public_path__ + "static/img/gaozhongyuwen2.00759460.jpg";